import React, { useEffect, useState } from "react";
import { useParams, Link } from "react-router-dom";
import '../css/ofertas.css';
import { ENDPOINTS } from "../config/api"; // <-- Importa tus endpoints

const DetalleOferta = () => {
  const { id } = useParams(); // Obtiene el id de la URL
  const [oferta, setOferta] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
      fetch(ENDPOINTS.getOfertaById(id))
      .then(response => response.json())
      .then(data => {
        setOferta(data);
        setLoading(false);
      })
      .catch(error => {
        console.error("Error al cargar oferta:", error);
        setLoading(false);
      });
  }, [id]);

  if (loading) {
    return <div className="text-center mt-5">Cargando oferta...</div>;
  }

  if (!oferta || oferta.error) {
    return <div className="text-center text-danger mt-5">Oferta no encontrada.</div>;
  }

  return (
    <div className="container mt-5 mb-5 ofertas">
      <div className="card shadow-sm p-4">
        <div className="row align-items-center">
          {/* Columna izquierda: texto */}
          <div className="col-md-8">
            <h2 className="mb-3 text-uppercase">{oferta.professional_program}</h2>
            <p className="fst-italic text-muted">{oferta.area_name}</p>

            <hr />

            <h5 className="mt-3">Descripción del cargo</h5>
            <p>{oferta.functions}</p>

            <div className="row mt-3">
              {/* Detalles */}
              <div className="col-md-6">
                <h5>Detalles</h5>
                <ul>
                  <li><strong>Tipo de contrato:</strong> {oferta.type_contract}</li>
                  <li><strong>Duración:</strong> {oferta.duration}</li>
                  <li><strong>Salario:</strong> ${oferta.salary}</li>
                  <li><strong>Lugar de ejecución:</strong> {oferta.place}</li>
                </ul>
              </div>

              {/* Requisitos */}
              <div className="col-md-6">
                <h5>Requisitos</h5>
                <ul>
                  <li><strong>Educación mínima:</strong> {oferta.minimum_education}</li>
                  <li><strong>Experiencia:</strong> {oferta.experience}</li>
                  <li><strong>Curso de altura:</strong> {oferta.curso_altura}</li>
                  <li><strong>Manipulación de alimentos:</strong> {oferta.curso_manipulacion_alimentos}</li>
                  <li><strong>Tarjeta profesional:</strong> {oferta.professional_card}</li>
                </ul>
              </div>
            </div>

            <div className="text-muted small mb-3">
              Publicado el: {oferta.created_at}
            </div>

            <div className="d-flex justify-content-between align-items-center">
              <Link to="/ofertas" className="btn btn-outline-purple">
                ← Volver a ofertas
              </Link>
              <Link to="/login" className="btn btn-outline-pink">
                Postularme
              </Link>
            </div>
          </div>

          {/* Columna derecha: imagen */}
          <div className="col-md-4 text-center">
            <img
              src="/images/avatarindex.png"
              alt="Oferta laboral"
              style={{ maxHeight: "350px", objectFit: "cover" }}
            />
          </div>
        </div>
      </div>
    </div>
  );
};

export default DetalleOferta;
